import { DexResultView, DexResultsSummaryView } from '@mark43/dex-api';
import { Icon, Box, Text } from '@cad-arc';
import React from 'react';
import { isCandidatesList, isDrilldownResult, isHit } from '../utils';

export function DexResultItemTrailingVisual({
    dexResult,
    dexResultsSummary,
    isSelected,
}: {
    dexResult?: DexResultView;
    dexResultsSummary?: DexResultsSummaryView;
    isSelected: boolean;
}): React.ReactElement {
    if (dexResult && (isCandidatesList(dexResult) || isDrilldownResult(dexResult))) {
        return (
            <Text color="tertiary" variant="caption">
                {dexResult.underlyingSource}
            </Text>
        );
    }
    if ((dexResult && isHit(dexResult)) || (dexResultsSummary && !!dexResultsSummary.isHit)) {
        return (
            <Icon
                icon="ExclamationPoint"
                size="md"
                color={isSelected ? 'brand.default' : 'raw.red.500'}
                data-testid="result-hit-icon"
            />
        );
    }
    if (dexResult?.mark43File || dexResultsSummary?.personSummaryViews?.[0]?.rmvImage) {
        return (
            <Icon
                icon="Image"
                size="md"
                color={isSelected ? 'brand.default' : undefined}
                data-testid="result-image-icon"
            />
        );
    }
    return <Box w="24px" h="24px" />;
}
